<div class="heading-title-section" [style]="style" [ngClass]="{'left-aligner': leftAlign}">
  @if(miniTitle){
    <h2  [ngClass]="mainiheading" class="heading-mini-title" [ngClass]="{'left-aligner': leftAlign}"  [style]="headingStyle">{{ miniTitle }}</h2>
  }
  <!-- <h2 *ngIf="title"  [ngClass]="mainheading" class="heading-main-title"> {{ title }}</h2> -->
  <h3 class="heading-title" [ngClass]="sectionheading" [ngClass]="{'left-aligner': leftAlign}" [style]="descriptionstyle" [innerHTML]="title"></h3>
  <p class="heading-desc" [style]="discription" [ngClass]="{'left-aligner': leftAlign}">
    {{ description }}
  </p>
</div>